// Logos for job sources and their scrapers, keyed by JobPost.source and by the
// scraper keys the admin Scrapers page uses (which differ only in case).
const LOGO_DIR = '/images/job-source-logos/'

const LOGOS = {
  olj:         'olj-icon-2.png',
  jobstreet:   'jobstreet-icon.png',
  cloudstaff:  'cloudstaff-logo-emblem.svg',
  emapta:      'emapta-logo.svg',
  bossjob:     'bossjob-icon.png',
  kalibrr:     'kalibrr-logo.png',
  indeed:      'indeed-icon.svg',
  upwork:      'upwork-icon.svg',
  vaworkersph: 'vaworkersph-logo.webp',
  findtalent:  'findtalent-icon.svg',
  hiretalent:  'hiretalent-logo.jpg',
  ofmjobs:     'ofmjobs-icon.svg',
}

// Upwork's rounded-square logo: white on the dark theme, black on light.
export function sourceLogo(key, theme) {
  const k = (key || '').toLowerCase()
  if (k === 'upwork' && theme === 'dark') return `${LOGO_DIR}upwork-icon-dark.svg`
  return LOGOS[k] ? LOGO_DIR + LOGOS[k] : null
}
